import Head from 'expo-router/head';
import React from 'react';

import { CheckoutScreen } from '@fhs/cart';
import { Payment } from '@fhs-legacy/frontend/src/pages/cart/payment/order-payment/payment';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export default function CartPaymentPage() {
  const enableFreshCheckout = useFlag('checkout-page-with-fresh-update');

  return (
    <>
      <Head>
        <title>Checkout - Firehouse Subs</title>
      </Head>
      {enableFreshCheckout ? <CheckoutScreen /> : <Payment />}
    </>
  );
}
